import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import BrandCard from './BrandCard';
import './BrandGrid.css';

const BrandGrid = () => {
    const [brands, setBrands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchTopBrands = async () => {
            try {
                const response = await api.get('/products/brands/top');
                setBrands(response.data);
            } catch (err) {
                console.error("Failed to fetch top brands:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTopBrands();
    }, []);

    if (isLoading || brands.length === 0) {
        return null;
    }

    return (
        <div className="brand-ticker-container">
            <h2 className="brand-ticker-heading">Trusted Partners & Top Brands</h2>
            <div className="brand-ticker-wrapper">
                {/* We need the track to slide.
                   We render the brand list twice to ensure seamless infinite scrolling.
                */}
                <div className="brand-ticker-track">
                    {brands.map((brand, index) => (
                        <BrandCard
                            key={`original-${index}`}
                            brandName={brand.brandName}
                            logoUrl={brand.logoUrl}
                        />
                    ))}
                    {/* Duplicate list for loop effect */}
                    {brands.map((brand, index) => (
                        <BrandCard
                            key={`duplicate-${index}`}
                            brandName={brand.brandName}
                            logoUrl={brand.logoUrl}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BrandGrid;